import { Fragment, useContext, useEffect } from "react";
import Seo from "../../components/utils/Seo";
import BodyUserProfile from "./BodyUserProfile";
import { useNavigate } from "react-router-dom";
import Base from "../Base";
import currentAdminContext from "../../dataManager/context/currentAdminContext";

const UserProfile = (props) => {
  //context variables
  const { currentAdmin } = useContext(currentAdminContext);

  return (
    <Fragment>
      <Seo
        title={`nti / user / ${currentAdmin?.getName}`}
        description={`informations personnels de ${currentAdmin?.getName} et l'ensembles des articles qu'il à enregistré`}
      />
      <Base>
        <BodyUserProfile />
      </Base>
    </Fragment>
  );
};

export default UserProfile;
